import api from "@/lib/api";

/**
 * Laddar ner en färdig bygglovsansökan-PDF från servern.
 * Frågar sökanden om mottagande kommun (valfri) för att förifylla den i PDF:en.
 */
export async function exportCasePdf(c) {
  if (!c) return;
  const municipality = window.prompt(
    "Vilken kommun ska ansökan skickas till? (valfri – visas i PDF:en)",
    c.municipality || "",
  );
  const params = municipality ? `?municipality=${encodeURIComponent(municipality)}` : "";
  const res = await api.get(`/crm/cases/${c.case_id}/pdf${params}`, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = `bygglovsansokan-${c.ref || c.case_id}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
